import React, { useState } from "react";
import * as Yup from "yup";
import { useFormik } from "formik";
import emailjs from "@emailjs/browser";
import { toast } from "react-toastify";
import { ImCancelCircle } from "@react-icons/all-files/im/ImCancelCircle";
import Popup from "reactjs-popup";

const PopupImage = (props) => {
  const [isLoading, setIsLoading] = useState(false);

  const formik = useFormik({
    initialValues: {
      name: "",
      phone: "",
      email: "",
      coursePreference: "",
      query: "",
    },
    validationSchema: Yup.object({
      name: Yup.string().required("Name is required"),
      phone: Yup.string()
        .required("Phone number is required")
        .matches(/^[6-9]\d{9}$/, "Must be a valid 10-digit Indian number"),
      coursePreference: Yup.string().required("Course preference is required"),
      email: Yup.string().email("Invalid email address"),
      query: Yup.string(),
    }),
    onSubmit: (values, { resetForm }) => {
      setIsLoading(true);

      const emailParams = {
        name: values.name,
        phone: values.phone,
        email: values.email || "No email submitted",
        coursePreference: values.coursePreference,
        query: values.query || "No query submitted",
        // Fill the rest of the template parameters to prevent raw text placeholders
        fatherName: "N/A",
        category: "N/A",
        lastQualification: "N/A",
        schoolCollege: "N/A",
        percentage: "N/A",
        to_email:
          "hodece@lkcengg.edu.in , assistantdirector@lkcengg.edu.in, rameshwer.banga@kclimt.com, sonu.dua@kclimt.com",
      };

      emailjs
        .send(
          "service_xlvsnfp_lkctc",
          "template_5h3hth9",
          emailParams,
          "T1o9eaPtzYX8qtsJj",
        )
        .then(
          (response) => {
            console.log("Email sent successfully!", response);
            toast.success("Inquiry submitted successfully!");
            resetForm();
            setIsLoading(false);
            props.closeModal();
          },
          (error) => {
            console.error("Email send error:", error);
            toast.error("Failed to send inquiry. Please try again.");
            setIsLoading(false);
          },
        );
    },
  });

  const imageUrl =
    props.noticeBoard?.[0]?.media?.[props.noticeBoard?.[0]?.media?.length - 1]
      ?.url;

  const contentStyle = {
    width: "90%",
    maxWidth: "650px",
    padding: "0px",
    border: "none",
    borderRadius: "12px",
    background: "#fff",
    boxShadow:
      "0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04)",
    overflow: "hidden",
  };

  return (
    <Popup
      open={props.open}
      closeOnDocumentClick
      onClose={props.closeModal}
      contentStyle={contentStyle}
    >
      <div className="relative flex flex-col w-full max-h-[95vh] overflow-y-auto bg-white text-gray-800">
        {/* Close Button */}
        <button
          type="button"
          onClick={props.closeModal}
          className="absolute top-3 right-3 z-50 p-1.5 rounded-full bg-white/90 hover:bg-white text-gray-700 hover:text-red-600 shadow-md transition-colors outline-none cursor-pointer"
          aria-label="Close modal"
        >
          <ImCancelCircle className="text-xl md:text-2xl" />
        </button>

        {/* Top Banner Image */}
        {imageUrl && (
          <div className="w-full flex-shrink-0 bg-gray-50 border-b border-gray-100">
            <a
              href="http://lkctc.edu.in/Admission/AdmissionForm"
              target="_blank"
              rel="noopener noreferrer"
              className="block w-full h-auto hover:opacity-95 transition-opacity"
            >
              <img
                src={imageUrl}
                alt="Admissions Query"
                className="w-full h-auto block"
              />
            </a>
          </div>
        )}

        {/* Bottom Area: Simplified Registration Form */}
        <div className="w-full p-5 md:p-6 flex flex-col justify-center">
          <div className="mb-4">
            <h2 className="text-xl md:text-2xl font-extrabold text-[#081C3A] tracking-tight">
              ADMISSIONS OPEN 2026-27
            </h2>
            <p className="text-xs text-gray-500 mt-1">
              Fill in your details below to query or register. Our admissions
              counselor will call you back.
            </p>
          </div>

          <form onSubmit={formik.handleSubmit} className="space-y-4">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
              {/* Name */}
              <div className="col-span-1">
                <label className="block text-xs font-bold text-gray-600 uppercase tracking-wider mb-1">
                  Name
                </label>
                <input
                  name="name"
                  type="text"
                  placeholder="Enter your name"
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  value={formik.values.name}
                  className={`w-full p-2.5 text-sm border rounded-lg outline-none transition-all ${
                    formik.touched.name && formik.errors.name
                      ? "border-red-500 focus:ring-1 focus:ring-red-400"
                      : "border-gray-300 focus:border-[#081C3A] focus:ring-1 focus:ring-[#081C3A]"
                  }`}
                />
                {formik.touched.name && formik.errors.name && (
                  <p className="text-red-500 text-xs mt-1 font-medium">
                    {formik.errors.name}
                  </p>
                )}
              </div>

              {/* Phone */}
              <div className="col-span-1">
                <label className="block text-xs font-bold text-gray-600 uppercase tracking-wider mb-1">
                  Phone Number
                </label>
                <input
                  name="phone"
                  type="tel"
                  placeholder="10-digit mobile number"
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  value={formik.values.phone}
                  className={`w-full p-2.5 text-sm border rounded-lg outline-none transition-all ${
                    formik.touched.phone && formik.errors.phone
                      ? "border-red-500 focus:ring-1 focus:ring-red-400"
                      : "border-gray-300 focus:border-[#081C3A] focus:ring-1 focus:ring-[#081C3A]"
                  }`}
                />
                {formik.touched.phone && formik.errors.phone && (
                  <p className="text-red-500 text-xs mt-1 font-medium">
                    {formik.errors.phone}
                  </p>
                )}
              </div>

              {/* Email */}
              <div className="col-span-1">
                <label className="block text-xs font-bold text-gray-600 uppercase tracking-wider mb-1">
                  Email Address{" "}
                  <span className="text-gray-400 font-normal">(Optional)</span>
                </label>
                <input
                  name="email"
                  type="email"
                  placeholder="your.email@example.com"
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  value={formik.values.email}
                  className={`w-full p-2.5 text-sm border rounded-lg outline-none transition-all ${
                    formik.touched.email && formik.errors.email
                      ? "border-red-500 focus:ring-1 focus:ring-red-400"
                      : "border-gray-300 focus:border-[#081C3A] focus:ring-1 focus:ring-[#081C3A]"
                  }`}
                />
                {formik.touched.email && formik.errors.email && (
                  <p className="text-red-500 text-xs mt-1 font-medium">
                    {formik.errors.email}
                  </p>
                )}
              </div>

              {/* Course Preference */}
              <div className="col-span-1">
                <label className="block text-xs font-bold text-gray-600 uppercase tracking-wider mb-1">
                  Course Preference
                </label>
                <select
                  name="coursePreference"
                  value={formik.values.coursePreference}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  className={`w-full p-2.5 text-sm border rounded-lg bg-white outline-none transition-all cursor-pointer ${
                    formik.touched.coursePreference &&
                    formik.errors.coursePreference
                      ? "border-red-500 focus:ring-1 focus:ring-red-400"
                      : "border-gray-300 focus:border-[#081C3A] focus:ring-1 focus:ring-[#081C3A]"
                  }`}
                >
                  <option value="">Select a course</option>
                  {[
                    "B.Tech Computer Science Engineering",
                    "B.Tech Data Science",
                    "B.Tech Electronics & Communication Engineering",
                    "B.Tech Mechanical Engineering",
                    "B.Tech Civil Engineering",
                    "B.Tech Artificial Intelligence & Machine Learning",
                    "BCA",
                    "MCA",
                    "BBA",
                    "MBA",
                    "B.Com (Hons)",
                    "Bachelor of Management Studies (Airlines, Tourism and Hospitality)",
                    "B.Pharmacy",
                    "D.Pharmacy",
                    "BHMCT",
                    "B.Sc. Graphics & Web Designing",
                    "B.Voc Interior Design",
                    "B.Sc. Medical Lab Sciences",
                    "B.Sc. Radiology and Imaging Technology",
                    "B.Sc. Medical Technology, Anaesthesia and Operation Theatre Technology",
                    "B.Sc. Dialysis Technology",
                    "B.Sc. Cardiac Care Technology",
                    "Bachelor of Nutrition and Dietetics (Honors)",
                    "M.Sc. Medical Microbiology",
                    "M.Sc. Radiology and Imaging Technology",
                    "M.Sc. Medical Technology, Anaesthesia and Operation Theatre Technology",
                    "M.Sc. Medical Lab Science (Biochemistry)",
                    "Master in Hospital Administration",
                    "B.Voc Software Development",
                    "B.Voc Automobile Servicing",
                    "B.Voc Electronics & IT",
                    "B.Voc Web Technology & Multimedia",
                    "B.Voc Hospitality and Catering Management",
                    "B.Voc E-Commerce and Digital Marketing",
                    "B.Voc Electrical Technician",
                    "Diploma (ME)",
                  ].map((course, i) => (
                    <option key={i} value={course}>
                      {course}
                    </option>
                  ))}
                </select>
                {formik.touched.coursePreference &&
                  formik.errors.coursePreference && (
                    <p className="text-red-500 text-xs mt-1 font-medium">
                      {formik.errors.coursePreference}
                    </p>
                  )}
              </div>

              {/* Query */}
              <div className="col-span-1 md:col-span-2">
                <label className="block text-xs font-bold text-gray-600 uppercase tracking-wider mb-1">
                  Drop Your Query{" "}
                  <span className="text-gray-400 font-normal">(Optional)</span>
                </label>
                <textarea
                  name="query"
                  placeholder="Any questions or remarks?"
                  onChange={formik.handleChange}
                  value={formik.values.query}
                  rows="2"
                  className="w-full p-2.5 text-sm border border-gray-300 rounded-lg outline-none focus:border-[#081C3A] focus:ring-1 focus:ring-[#081C3A] transition-all resize-none"
                ></textarea>
              </div>

              {/* Submit Button */}
              <div className="col-span-1 md:col-span-2">
                <button
                  type="submit"
                  disabled={isLoading}
                  className={`w-full bg-[#081C3A] text-white p-3 rounded-lg font-semibold hover:bg-[#0a3a81] transition-colors flex justify-center items-center cursor-pointer shadow-md ${
                    isLoading ? "opacity-60 cursor-not-allowed" : ""
                  }`}
                >
                  {isLoading ? (
                    <div className="h-5 w-5 border-2 border-white border-t-transparent rounded-full animate-spin"></div>
                  ) : (
                    "Submit Inquiry"
                  )}
                </button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </Popup>
  );
};

export default PopupImage;
